module.exports = __webpack_public_path__ + "static/media/click.217b91bb.mp3";